export const FILE_VSKUS = ['v-w9-e-sign@1.0', 'v-w9-e-sign-sandbox@1.0'];

export const VSKU_NAMES = {
  'v-pro-license@1.0': 'Professional License',
  'v-pro-license-sandbox@1.0': 'Professional License',
  'v-pro-license@2.0': 'Professional License',
  'v-pro-license-sandbox@2.0': 'Professional License',
  'v-pro-license@2.1': 'Professional License',
  'v-pro-license-w-addr@2.0': 'Professional License with Address',
  'v-pro-license-w-addr-sandbox@2.0': 'Professional License with Address Sandbox',
  'v-bus@1.0': 'Business Verification',
  'v-bus-tin@1.0': 'Business Verification',
  'v-bus-info-wizard-sandbox@1.0': 'Business Verification',
  'v-bus-info-wizard@1.0': 'Business Verification',
  'v-bus-info-risk-wiz-sandbox@1.0': 'Business Verification',
  'v-bus-info-risk-wizard@1.0': 'Business Verification',
  'v-business-contact@1.0': 'Business Contact',
  'v-bus-w-tin@1.0': 'Business Verification',
  'v-bus-w-tin-sandbox@1.0': 'Business Verification',
  'v-proof-of-business@1.0': 'Proof of Business',
  'v-proof-of-business-sandbox@1.0': 'Proof of Business',
  'v-w9-document@1.0': 'W-9 Document',
  'v-w9-document-sandbox@1.0': 'W-9 Document',
  'v-w9-e-sign@1.0': 'W-9 E-Sign',
  'v-w9-e-sign-sandbox@1.0': 'W-9 E-Sign',
  'v-insurance-sandbox@1.0': 'Insurance',
  'v-insurance@1.0': 'Insurance',
  'v-mobile-verification@1.0': 'Mobile Number',
  'v-personal-w-ssn@1.0': 'Submitter Information',
  'v-personal-w-ssn-sandbox@1.0': 'Submitter Information',
  'v-personal-w-occ@1.0': 'Submitter Information Occupation',
  'v-personal-w-occ-sandbox@1.0': 'Submitter Information Occupation',
  'v-bus-pre-places@1.0': 'Business Presence Places',
  'v-bus-pre-places-sbx@1.0': 'Business Presence Places',
  'v-bus-pre-web-srch@1.0': 'Business Presence Web Search',
  'v-bus-pre-web-srch-sbx@1.0': 'Business Presence Web Search',
  'v-bus-pre-web-srch-dom-indiv@1.0': 'Business Presence Web Search Domain Individual',
  'v-bus-pre-web-srch-do-in-sbx@1.0': 'Business Presence Web Search Domain Individual',
  'v-bus-pre-web-srch-dom-bus@1.0': 'Business Presence Web Search Domain Business',
  'v-bus-pre-web-srch-do-bu-sbx@1.0': 'Business Presence Web Search Domain Business',
  'v-bus-pre-prof-soc-net@1.0': 'Business Presence Prof Social Network',
  'v-bus-pre-prof-soc-net-sbx@1.0': 'Business Presence Prof Social Network',
  'v-bus-risk-nl-wiz@1.0': 'Business Risk Wizard Without Liens',
  'v-bus-risk-nl-wiz-sandbox@1.0': 'Business Risk Wizard Without Liens',
  'v-ftc-fcc-sanctions@1.0': 'FTC/FCC Sanctions',
  'v-ftc-fcc-sanctions-sandbox@1.0': 'FTC/FCC Sanctions',
};

export const CLAIM_NAMES = {
  'licenseeName': 'Licensee Name',
  'licenseIdentifier': 'License Number',
  'licenseStatus': 'License Status',
  'licenseStatusAsIs': 'License Status As Is',
  'licenseType': 'License Type',
  'licenseCategory': 'License Category',
  'licenseAuthorityBoard': 'License Authority Board',
  'licenseSubtype': 'License Subtype',
  'licenseTypeAsIs': 'License Type As Is',
  'licenseIssuedDate': 'License Issue Date',
  'licenseExpirationDate': 'License Expiration Date',
  'licenseAddress': 'License Address',
  'jurisdiction': 'Issuing Authority',
  'businessWebsiteUrl': 'Business Website',
  'taxIdentificationNumber': 'Taxpayer Identification Number (TIN)',
  'businessAddress': 'Business Address',
  'businessEmail': 'Business Email',
  'businessName': 'Business Name',
  'fileName': 'File Name',
  'insuranceAgentEmail': 'Email Address',
  'insuranceBeneficiaryFirstName': 'First Name',
  'insuranceBeneficiaryLastName': 'Last Name',
  'insuranceBeneficiaryEmail': 'Business Email',
  'insuranceRegisteredBusinessName': 'Business Name',
  'insuranceRegisteredBusinessAddress': 'Business Address',
  'insuranceTaxIdentificationNumber': 'Taxpayer Identification Number (TIN)',
  'insuranceRequirementsTemplate': 'Requirements Template',
  'insuranceRequestorId': 'Requestor ID',
  'insurancePolicies': 'Policies',
  'status': 'Status',
  'statusAsIs': 'Status As Is',
  'registrationDate': 'Registration Date',
  'liens': 'Liens',
  'litigations': 'Litigations',
  'bankruptcies': 'Bankruptcies',
  'consentToMobileNumberVerification': 'Mobile Number Verified',
  'mobileNumber': 'Mobile Number',
  'firstName': 'First Name',
  'lastName': 'Last Name',
  'dateOfBirth': 'Date of Birth',
  'lastFourSsn': 'Last 4 of SSN',
  'occupation': 'Occupation',
  'citizenshipUS': 'US Citizen',
  'disregardedEntityName': 'Disregarded Entity Name',
  'businessType': 'Business Type',
  'taxIdentificationNumberType': 'Taxpayer Identification Number Type',
  'businessPhone': 'Business Phone',
  'businessWebsite': 'Business Website',
  'businessMailingAddress': 'Mailing Address',
  'businessId': 'Business ID',
  'individualName': 'Individual Name',
  'relatedIndividuals': 'Related Individuals',
  'individualEmailAddress': 'Individual Email Address',
  'individualConnectionsCount': 'Individual Connections Count',
  'individualProfileFirstDetectedTimestamp': 'Individual Profile First Detected Timestamp',
  'businessProfileFirstDetectedTimestamp': 'Business Profile First Detected Timestamp',
  'placeId': 'Place ID',
  'reviewCount': 'Review Count',
  'rating': 'Rating',
  'businessStatus': 'Business Status',
  'webPresenceTitle': 'Web Presence Title',
  'webPresenceDescription': 'Web Presence Description',
  'webPresenceUrl': 'Web Presence URL',
  'webPresenceFoundTimestamp': 'Web Presence Found Timestamp',
  'naturalKey': 'Natural Key',
  'adverseActionStatusAsIs': 'Adverse Action Status As Is',
  'adverseActionStatus': 'Adverse Action Status',
  'issuingAgencyName': 'Issuing Agency Name',
  'dataFreshness': 'Data Freshness',
  'regulatoryActions': 'Regulatory Actions',
};

export const CLAIM_TYPE = {
  licenseExpirationDate: 'date',
  licenseIssuedDate: 'date',
  registrationDate: 'date',
  webPresenceFoundTimestamp: 'date',
};
